import { PropsWithChildren } from "react"

import { Popover } from "@mui/material"
import { bindPopover } from "material-ui-popup-state"
import { PopupState } from "material-ui-popup-state/hooks"

type CalendarPopoverProps = {
  popupState: PopupState
}

const CalendarPopover = ({
  popupState,
  children,
}: PropsWithChildren<CalendarPopoverProps>) => (
  <Popover
    {...bindPopover(popupState)}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "left",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "left",
    }}
    disableScrollLock
  >
    {children}
  </Popover>
)

export default CalendarPopover
